import _ from 'lodash';
import { create, all } from 'mathjs';

const config = {};
const math = create(all, config);

function remoweWhiteSpace(item) {
  let reg = /\s/gi;
  return item.replace(reg, '');
}
function fixNestedUnit(item) {
  let reg = /(\d+[a-zA-z]+){2,}/gi;
  let data = item.match(reg);
  if (_.isNil(data)) {
    return item;
  }
  let resoult = _.chain(data).map(splitNestedUnit).value();
  resoult = _.reduce(
    data,
    (str, marker, index) => {
      return str.replace(marker, resoult[index]);
    },
    item
  );
  return resoult;
}
function splitNestedUnit(item) {
  let reg = /\d+[a-zA-z]+/g;
  let data = item.match(reg);
  return data.join('+');
}
function splitLRvalue(item) {
  let reg = /=/gi;
  let data = item.split(reg);
  if (data.length <= 1) {
    return { lValue: data[0], rValue: '' };
  }
  return { lValue: data[0], rValue: data[1] };
}
function splitByLine(item) {
  let reg = /[\r\n|\r|\n]/gi;
  let data = item.split(reg);
  return _.compact(data);
}
function splitByEqual(expression) {
  let data = expression.split('=');
  return data;
}
function checkStructure(item) {
  const regExp = /={2,}/g;
  // TODO: add check for '20=20='
  if ((item.match(regExp) || []).length > 1) {
    return false;
  }
  return true;
}
function checkIfMultiple(item) {
  const regExp = /=/g;
  if ((item.match(regExp) || []).length > 1) {
    return false;
  }
  return true;
}
function replaceChar(string, rule) {
  const regExp = new RegExp(`\\${rule.char}`, 'g');
  return string.replace(regExp, rule.replace);
}
function normalizeExpressionValue(item) {
  let tableOfReplace = [
    { char: ':', replace: '/' },
    { char: ',', replace: '.' },
    { char: '[', replace: '(' },
    { char: ']', replace: ')' },
    { char: '{', replace: '(' },
    { char: '}', replace: ')' },
  ];
  let data = item;
  _.each(tableOfReplace, (o) => {
    if (data.lValue) {
      data.lValue = replaceChar(data.lValue, o);
    }
    if (data.rValue) {
      data.rValue = replaceChar(data.rValue, o);
    }
  });
  return data;
}
function evaluateValue(data) {
  let value;
  try {
    value = math.evaluate(data);
  } catch (e) {
    // console.log('e', e);
    return;
  }
  return value;
}

function calculateLvalue(item) {
  return { lValue: evaluateValue(item.lValue), rValue: item.rValue };
}
function calculateRvalue(item) {
  return { lValue: item.lValue, rValue: evaluateValue(item.rValue) };
}

function expressionProcess(expression) {
  if (!_.isArray(expression)) {
    expression = [expression];
  }
  let expressionParsed = _.chain(expression)
    .map(remoweWhiteSpace)
    .map(fixNestedUnit)
    .map(splitLRvalue)
    .map(normalizeExpressionValue)
    .map(calculateLvalue)
    .map(calculateRvalue)
    .value();
  return expressionParsed;
}
function expressionTest(expression) {
  let calculated = false;
  let testString = expression;
  if (!_.isArray(testString)) {
    testString = [testString];
  }
  let test = _(testString).map(remoweWhiteSpace).map(checkIfMultiple).value();
  test = test[0];
  if (test) {
    calculated = expressionProcess(expression);
    if (hasUnit(calculated)) {
      calculated = _.reduce(
        calculated,
        (accu, elem, index) => {
          let test = false;
          if (!_.isNil(elem.lValue)) {
            test = testValueWitchUnits(elem);
          }
          return accu && test;
        },
        true
      );
    } else {
      calculated = _.reduce(
        calculated,
        (accu, elem, index) => {
          let test = false;
          if (!_.isNil(elem.lValue)) {
            test = elem.lValue === elem.rValue;
          }
          return accu && test;
        },
        true
      );
    }
  }
  return calculated;
}
function testValueWitchUnits(obj) {
  let lVal = _.isObject(obj.lValue) ? math.format(obj.lValue.value, { precision: 14 }) : false;
  let rVal = _.isObject(obj.rValue) ? math.format(obj.rValue.value, { precision: 14 }) : false;

  return lVal === rVal;
}

function hasUnit(obj) {
  let test = _.reduce(
    obj,
    (accu, current) => {
      return accu && _.isObject(current.lValue) && _.isObject(current.rValue);
    },
    true
  );
  return test;
}
function isEqual(object1, object2) {
  if (object1.lValue instanceof math.Unit) {
    return object1.lValue.equals(object2.lValue);
  }
  return object1.lValue === object2.lValue && object1.rValue === object2.rValue && object1.lValue === object2.rValue;
}

function expressionCalculate(expression, rawData = false) {
  let calculated = expressionProcess(expression);
  let calculatedValue = _.isArray(calculated) ? calculated[0].lValue : calculated.lValue;
  if (_.isObject(calculatedValue) && !rawData) {
    calculatedValue = calculatedValue.toString();
  }
  return calculatedValue;
}
function expressionTestMultipleEqual(expression) {
  let splitExpesion = splitByEqual(expression);
  let value = _.reduce(
    splitExpesion,
    (accu, current, index, array) => {
      if (array[index + 1]) {
        let stringtest = `${current}=${array[index + 1]}`;
        return accu && expressionTest(`${current}=${array[index + 1]}`);
      }
      return accu;
    },
    true
  );
  return value;
}
function expressionTestMultipleLine(expression) {
  let value;
  let lines = splitByLine(expression);
  let testStructur = _.reduce(
    lines,
    (acc, current) => {
      let testString = current;
      if (!_.isArray(testString)) {
        testString = [testString];
      }
      let test = _(testString).map(remoweWhiteSpace).map(checkStructure).value();
      test = test[0];
      return acc && test;
    },
    lines.length > 0
  );
  if (testStructur) {
    value = _.reduce(
      lines,
      (acc, line) => {
        return acc && expressionTestMultipleEqual(line);
      },
      true
    );
  }
  return value;
}

function mathematicaTest() {
  let strings = [
    '{2+[(2  *  2):2 ]* 1} * 3^2=10 +[ 6- (7* 2)]: 2',
    '  1+ 2 +   3+4=10',
    '[(1:1) *1  + 2] +   3+4=10',
    '[(1:1):1  + 2] +   3+4=10',
    '[(1:1 )  + 2] +  3+4=10',
    '  1*1+ 2 +   3+4=10',
    '1:1+ 2 +   3+4=10',
    '1    -   1+1+ 2 +   3+4=10',
    '[(1:1 )  + 2] +   3+4=10',
    '1-(-1)',
    '1 kg +10 dag=1,1kg',
    '1 cm +10 m=10,01m',
    '1 cm +10 m=1,1kg',
    '500g + 500g = 1kg ',
    '500g + 500g = 1kg ',
  ];
  let claculateString = [
    '{2+[(2  *  2):2 ]* 1} * 3^2=10 +[ 6- (7* 2)]: 2',
    '  1+ 2 +   3+4',
    '[(1:1) *1  + 2] +   3+4',
    '[(1:1):1  + 2] +   3+4',
    '[(1:1 )  + 2] +  3+4',
    '1 kg +10 dag',
    '1 m +10 cm',
    '500g+500 g',
    '0,5kg+500 g',
    '1 kg +10 cm',
  ];
  let testUnitString = [
    { val: '1  +0.10 =1.1', correct: '1 +0.10 =1.1' },
    { val: '1 m +10 cm=1.11m', correct: '1 m +10 cm=1.1m' },
    { val: '1 kg +10 cm=1.09m', correct: '1 kg +10 cm=1.1m' },
    { val: '1  +0.10 =1.1', correct: '1 kg +10 cm=1.1m' },
    { val: '1  +0.10 =1.1', correct: '1 +10 =1.1' },
    { val: '1kg  +0.10 kg=1.1kg', correct: '1 kg +10 kg=1.1kg' },
    {
      val: '1m 3 cm 1 mm + 1 mm = 1m 3cm 4mm',
      correct: '1m 3 cm 1 mm + 1 mm = 1m 3cm 4mm',
    },
    { val: '1 kg +10 dag=1.1kg', correct: '1 kg +10 dag= 1.1kg' },
    { val: '1 m +10 cm=1.10m', correct: '1 m +10 cm= 110cm' },
    { val: '500g + 500g = 1kg ', correct: '500g + 500g = 1000g ' },
    { val: '3cm + 6cm 4mm = 9cm 4mm', correct: '3cm + 6cm 4mm = 9cm 4mm' },
    { val: '3cm + 6 cm 4 mm =  9.4 cm', correct: '3cm + 6 cm 4 mm = 9,4 cm' },
    {
      val: '3cm 1mm + 6 cm 4 mm =  9.5 cm',
      correct: '3cm 1mm+ 6 cm 4 mm = 9,4 cm',
    },
    { val: '3cm + 6 cm 1mm=  9 cm 1mm', correct: '3cm+ 6 cm 1mm = 9 cm 1mm' },
    { val: '30mm+64mm=94mm', correct: '30mm + 64mm = 94mm' },
    { val: '30mm+64mm=94mm', correct: '30mm+64mm=94mm' },
    { val: '30 mm + 64 mm = 94 mm', correct: '30 mm + 64 mm = 94 mm' },
    {
      val: '1m 3 cm 1 mm + 1 mm = 1m 3cm 2mm',
      correct: '1m 3 cm 1 mm + 1 mm = 1m 3cm 2mm',
    },
  ];
  let multipleEqualTestSrings = [
    '{2+[(2  *  2):2 ]* 1} * 3^2=10+5+5+5-5+16=22+8+6',
    '10+10=20+-2+2=20',
    '10+10=20+-2+2=20-20+40:2=1+19=70:2-15',
    '10+10=20+-2+2=20-20+40:2=1+19=70:2-15=1',
  ];
  // let multipleLineTestSrings = ['10+10=20=20-10+20/2\n10-5+5+10=20\n30-10=20', '10+10=20\n10-5+5+10=20\n30-10=10'];
  let multipleLineTestSrings = [
    '10+10=20=20-10+20/2\n10-5+5+10=20\n30-10=20',
    '10+10=20=20-10+20/2\n10-5+5+10=20\n30-10= = +20',
  ];

  let testConfig = false;
  let testUnit = true;
  let calculateConfig = false;
  let multipleEqualConfig = false;
  let multipleLineConfig = false;

  let value;

  if (testConfig && !multipleEqualConfig && !multipleLineConfig) {
    value = _.map(strings, (item) => {
      return expressionTest(item);
    });
  }
  if (calculateConfig) {
    value = _.map(claculateString, (item) => {
      var rawData = false;
      return expressionCalculate(item, rawData);
    });
  }
  if (testUnit) {
    value = _.map(testUnitString, (item) => {
      var rawData = false;
      let expr1 = expressionProcess(item.val);
      expr1 = expr1[0];
      let expr2 = expressionProcess(item.correct);
      expr2 = expr2[0];
      let test1 = expressionTest(item.val);
      return test1 && isEqual(expr1, expr2);
    });
  }
  if (testConfig && multipleEqualConfig) {
    value = _.map(multipleEqualTestSrings, (item) => {
      return expressionTestMultipleEqual(item);
    });
  }
  if (testConfig && !multipleEqualConfig && multipleLineConfig) {
    value = _.map(multipleLineTestSrings, (item) => {
      return expressionTestMultipleLine(item);
    });
  }
  // console.log('value', value);
  return value;
}
// mathematicaTest();

export {
  expressionProcess,
  expressionTest,
  expressionCalculate,
  expressionTestMultipleEqual,
  expressionTestMultipleLine,
  hasUnit,
  isEqual,
};
